import {
    DisclaimerReferenceBadge,
    styled,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import type {DefaultTheme} from 'styled-components'
import legalNotesLayerHandle from './handles/legalNotesLayerHandle'
import {
    setIsLegalNotesOpen,
    setLegalNotesText,
} from '../../../features/general/generalSlice'
import {useFeatureServices} from '../../../use-feature-services'
import {LayerManagerV2} from '@volkswagen-onehub/layer-manager'
import {useDispatch} from 'react-redux'

const ButtonContainer = styled.span`
    position: absolute;
    left: 0;
    bottom: 0;
    padding: ${({theme}: {theme: DefaultTheme}) => theme.size.static250};
`

export default function DisclaimerButton(props: {
    disclaimer: string
}): React.JSX.Element {
    const dispatch = useDispatch()

    const {'layer-manager': layerManager} = useFeatureServices() as {
        'layer-manager': LayerManagerV2
    }

    return (
        <>
            <ButtonContainer>
                <DisclaimerReferenceBadge
                    aria-label="Mostra nota nr. 1"
                    variant="large"
                    onClick={(e: React.MouseEvent): void => {
                        e.preventDefault()

                        legalNotesLayerHandle(layerManager, () => {
                            dispatch(setIsLegalNotesOpen(false))
                            dispatch(setLegalNotesText(''))
                        })
                        dispatch(setIsLegalNotesOpen(true))
                        dispatch(setLegalNotesText(props.disclaimer))
                    }}
                >
                    1
                </DisclaimerReferenceBadge>
            </ButtonContainer>
        </>
    )
}
